import React, { Fragment } from "react";
import moment from "moment";
import Moment from "react-moment";
import PropTypes from "prop-types";
import { Flex, Box } from "grid-styled";
import { reduxForm, Field } from "redux-form";
import Text from "../Text";
import { InputContainer, DatePicker } from "../forms";
import { measurementDisplay } from "../../utils/helpers";
import { Panel, PanelHeader, PanelBody } from "../Panel";
import Button from "../Button";
import { getTransmittals } from "../../api";

const ProjectInfoForm = reduxForm({
  form: "projectInfoEdit"
})(({ handleSubmit, onCancel }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Box pb={2}>
        <Field
          name="finalPaymentDate"
          labelText="Final Payment Date reported on"
          component={InputContainer}
          fieldComponent={DatePicker}
          utc
        />
      </Box>
      <Flex justify="flex-end">
        <Button type="button" onClick={onCancel} style={{ marginRight: 4 }}>
          Cancel
        </Button>
        <Button type="submit" variant="primary">
          Save
        </Button>
      </Flex>
    </form>
  );
});

class ProjectInfoCard extends React.Component {
  static propTypes = {
    job: PropTypes.object,
    onSave: PropTypes.func.isRequired
  };

  state = {
    loading: false,
    error: null,
    transmittals: [],
    editing: false
  };

  componentDidMount() {
    this.loadTransmittals();
  }

  loadTransmittals = () => {
    this.setState({ loading: true });

    getTransmittals(this.props.job.id)
      .then(transmittals => {
        this.setState({ transmittals, loading: false });
      })
      .catch(error => {
        this.setState({ error, loading: false });
      });
  };

  save = values => {
    return this.props
      .onSave({
        finalPaymentDate: moment(values.finalPaymentDate).format("YYYY-MM-DD")
      })
      .then(this.toggleEdit);
  };

  toggleEdit = () => {
    this.setState({ editing: !this.state.editing });
  };

  renderMeasurements() {
    const { transmittals } = this.props;
    return transmittals.map(transmittal => {
      return transmittal.measurements.map(measurement => (
        <Text>
          {measurement.source && <b>{measurement.source}</b>}
          <b>{measurement.field_name}</b>
          {measurement.amount} {measurementDisplay(measurement.data_type)}
        </Text>
      ));
    });
  }

  renderInfo() {
    const { job } = this.props;
    return (
      <Fragment>
        <Text>
          <b>Final Payment Date reported on</b>
          <br />
          {job.finalPaymentDate ? (
            <Moment format="MMM D, YYYY" utc>
              {job.finalPaymentDate}
            </Moment>
          ) : (
            "Payment not yet reported"
          )}
        </Text>
      </Fragment>
    );
  }

  renderForm() {
    const { job } = this.props;
    const initialValues = {
      finalPaymentDate: job.finalPaymentDate || moment()
    };

    return (
      <ProjectInfoForm
        initialValues={initialValues}
        onSubmit={this.save}
        onCancel={this.toggleEdit}
      />
    );
  }

  render() {
    const { contact, onSave, ...otherProps } = this.props;
    const { editing } = this.state;
    return (
      <Panel {...otherProps}>
        <PanelHeader>
          <span>Project Details</span>
          <Button
            onClick={this.toggleEdit}
            style={{ marginLeft: "auto" }}
            size="sm"
            disabled={editing}
          >
            {editing ? "Editing" : "Edit"}
          </Button>
        </PanelHeader>
        <PanelBody>{editing ? this.renderForm() : this.renderInfo()}</PanelBody>
      </Panel>
    );
  }
}

export default ProjectInfoCard;



// WEBPACK FOOTER //
// ./src/components/job/ProjectInfoCard.js